<template>
  <v-data-table
    :headers="customerDataTableHeaders"
    :items="customerList"
    class="elevation-1"
    :loading="isLoadingCustomer"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :server-items-length="totalRows"
    :options="currentOptions"
    @update:options="updateOptions"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('customer_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchCustomer"
          append-icon="mdi-magnify"
          :label="$t('customer_search_number')"
          single-line
          hide-details
          clearable
          @input="getSomeCustomer"
        ></v-text-field>
      </v-toolbar>
    </template>
  </v-data-table>
</template>

<script>
import { HttpCustomer } from '@/js/http-Manager'
import axios from 'axios'

export default {
  name: 'Customer',
  data: () => ({
    customerList: [],
    searchCustomer: '',
    isLoadingCustomer: true,
    updateItemSource: null,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    customerSomeSource: null
  }),
  async mounted () {
    this.getSomeCustomer()
    this.getTotalCount()
  },
  computed: {
    customerDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'ShortName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'FullName' },
        { text: this.$t('quotation_tel'), align: 'start', value: 'Tel' },
        { text: this.$t('quotation_fax'), align: 'start', value: 'Fax' },
        { text: this.$t('quotation_attribute'), align: 'start', value: 'Attribute' },
        { text: this.$t('quotation_invoice_address'), align: 'start', value: 'InvoiceAddress' }
      ]
    }
  },
  methods: {
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          number: '',
          name: this.searchCustomer
        }
        let response = await HttpCustomer.GetCustomerForDataTableCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getSomeCustomer(val)
    },
    async getSomeCustomer (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingCustomer = true
      let param = {
        SearchCustomer: this.searchCustomer,
        PerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      if (this.customerSomeSource) {
        this.customerSomeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.customerSomeSource = cancelToken.source()
      let response = await HttpCustomer.GetCustomerForDataTable(
        param,
        this.customerSomeSource.token
      )
      this.isLoadingCustomer = false
      if (response) {
        this.customerList = response.status === 200 ? response.data.Data : []
        this.customerSomeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    }
  }
}
</script>
